<template>
  <div>
    <generic-header />

    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1 class="text-center mb-4">Page Not Found</h1>
          <p class="text-center">
            Apologies, but the page you were looking for could not be found. Please make sure you have entered the correct url.<br />
            <router-link to="/" class="btn mt-5 text-center">
              Back to home
            </router-link> 
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import metadata from '../util/metadata';
import GenericHeader from '../components/GenericHeader';

export default {
  name: 'Home',
  metaInfo: {
    title: `Page Not Found | ${metadata.GLOBAL.PAGE_TITLE}`,
    meta: [
      { name: 'description', content: 'Sorry, this page is not found' }
    ]
  },
  components: { GenericHeader },
}
</script>